import { Pipe, PipeTransform } from '@angular/core';
import {PlayerSideUIChoices} from '../../../features/profile/enums/player-side.enum';

@Pipe({
  name: 'ageRange'
})
export class AgeRangePipe implements PipeTransform {

  transform(age: number): string {
    if (isNaN(age)) {
      return '-'
    }
    const maxAge = age;
    const minAge = age-2;
    return `${minAge} - ${maxAge}`
  }
}
